import { ACTION_APP_LOADED, ACTION_COMPLETED, ACTION_FAILED, ACTION_PENDING_APPROVAL, ACTION_SET_MODAL_STATE } from "../reducers/constants";
import { AppIdentifier } from "../../types";
import { dispatchActionBasedOnAppIdentifier } from "../../utils";

export const openModal = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_SET_MODAL_STATE, { isAppActive: true })
}

export const closeModal = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_SET_MODAL_STATE, { isAppActive: false })
}

export const appLoaded = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_APP_LOADED, { isAppLoaded: true })
}

export const appPendingApproval = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_PENDING_APPROVAL, {})
}

export const appCompleted = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_COMPLETED, {})
}

export const appFailed = (appIdentifier: AppIdentifier) => {
  dispatchActionBasedOnAppIdentifier(appIdentifier, ACTION_FAILED, {})
}